var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{attrs:{"label":_vm.label,"prop":_vm.field,"rules":_vm.rules,"size":"small"}},[_c('sme-editor',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder},on:{"input":function($event){_vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }